import { render, staticRenderFns } from "./textarea-with-presets.vue?vue&type=template&id=e32d45a0&scoped=true&"
import script from "./textarea-with-presets.vue?vue&type=script&lang=js&"
export * from "./textarea-with-presets.vue?vue&type=script&lang=js&"
import style0 from "./textarea-with-presets.vue?vue&type=style&index=0&id=e32d45a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32d45a0",
  null
  
)

export default component.exports